var styles = {"chip":"Chip-module_chip__3f0zv","selected":"Chip-module_selected__zQzuf","small":"Chip-module_small__GfjIC","large":"Chip-module_large__LSddQ","leading":"Chip-module_leading__kdqJ-","trailing":"Chip-module_trailing__Vr18B"};

export { styles as default };
